import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { ProtectedLayout } from '../features/layout/ProtectedLayout/ProtectedLayout';
import { BillerPortalLayoutComponent } from '../features/billerPortal/layouts/BillerPortalLayoutComponent/BillerPortalLayoutComponent';
import BillerPortalContainer from '../contexts/BillerPortalContainer/BillerPortalContainer';
import useChangePage, { billerPortalUrl } from '../hooks/useChangePage/useChangePage';
import { RoleTypeEnum } from '../uc-api-sdk';

// Lazy loaded components
const DumpReportPageComponent = lazy(() => import('../features/billerPortal/reports/component/DumpReportPageComponent/DumpReportPageComponent'));
const UserProfileComponent = lazy(() => import('../features/user/component/UserProfileComponent/UserProfileComponent'));
const BillerPortalUtilitiesPage = lazy(() => import('../features/billerPortal/layouts/BillerPortalUtilitiesPage.tsx/BillerPortalUtilitiesPage'));
const BillerPortalBillableTimeReviewPageComponent = lazy(() => import('../features/billerPortal/utilities/component/BillerPortalBillableTimeReviewPageComponent/BillerPortalBillableTimeReviewPageComponent'));
const PriorAuthPageComponent = lazy(() => import('../features/Insurance/component/PriorAuthPageComponent/PriorAuthPageComponent'));
const BillerPortalMissingInformationPatientPageComponent = lazy(() => import('../features/billerPortal/utilities/component/BillerPortalMissingInformationPatientPageComponent/BillerPortalMissingInformationPatientPageComponent'));
const InsuranceAndEligibilityPageComponent = lazy(() => import('../features/Insurance/component/InsuranceAndEligibilityPageComponent/InsuranceAndEligibilityPageComponent'));
const BillerPortalBillingDocsPage = lazy(() => import('../features/billerPortal/layouts/BillerPortalBillingDocsPage/BillerPortalBillingDocsPage'));
const PaymentAndInvoicePageComponent = lazy(() => import('../features/ClinicStaffBilling/component/PaymentAndInvoicePageComponent/PaymentAndInvoicePageComponent'));
const BillingReportPageComponent = lazy(() => import('../features/billingReport/component/BillingReportPageComponent/BillingReportPageComponent'));
const PatientProfilePageComponent = lazy(() => import('../features/patient/page/PatientProfilePageComponent/PatientProfilePageComponent'));
const ReviseBillingCodePageComponent = lazy(() => import('../features/billerPortal/utilities/component/ReviseBillingCodePageComponent/ReviseBillingCodePageComponent'));

export const createBillerPortalRoutes = () => {
  const page = useChangePage();

  return (
    <Route
      path={billerPortalUrl}
    >
      <Route
        element={<ProtectedLayout roleWhiteList={[RoleTypeEnum.BILLER]} />}
      >
        <Route
          index
          element={<Navigate to={page.createBillerPortalReportsUrl()} />}
        />
        <Route element={<BillerPortalLayoutComponent />}>
          <Route
            path={page.createBillerPortalReportsUrl()}
            element={<DumpReportPageComponent />}
          />
          <Route
            path={page.createBillerPortalSettingsUrl()}
            element={<UserProfileComponent />}
          />
          <Route
            path={page.createBillerPortalUtilitiesUrl()}
            element={<BillerPortalUtilitiesPage />}
          />
          <Route path={page.createBillerPortalUtilitiesUrl()}>
            <Route index element={<BillerPortalUtilitiesPage />} />
            <Route path="/biller-portal/utilities/billable-time-review" element={<BillerPortalBillableTimeReviewPageComponent />} />
            <Route path="/biller-portal/utilities/prior-auth" element={<PriorAuthPageComponent />} />
            <Route path="/biller-portal/utilities/list-missing-information-report-version" element={<BillerPortalMissingInformationPatientPageComponent />} />
            <Route path="/biller-portal/utilities/insurance-and-eligibility" element={<InsuranceAndEligibilityPageComponent />} />
            <Route path="/biller-portal/utilities/revise-billing-code" element={<ReviseBillingCodePageComponent />} />
          </Route>
          <Route
            path={page.createBillerPortalBillingDocsUrl()}
          >
            <Route index element={<BillerPortalBillingDocsPage />} />
            <Route path="/biller-portal/billing/payment-and-invoice" element={<PaymentAndInvoicePageComponent />} />
            <Route path="/biller-portal/billing/billing-and-patient-reports" element={<BillingReportPageComponent />} />
          </Route>

          <Route element={<BillerPortalContainer />}>
            <Route path={`${billerPortalUrl}/patients/:patientId`}>
              <Route index element={<PatientProfilePageComponent />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>
  );
};

export default createBillerPortalRoutes;
